import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import TofuProduct from 'models/TofuProduct'
import TofuNutrition from './TofuNutrition'
import TofuPackage from './TofuPackage'

const productOptions = {
  nutritionInfo: <TofuNutrition />,
  packagingInfo: <TofuPackage />,
  productTitle: 'Brand Specific Tofu',
  model: TofuProduct,
  validCategories: ['02'],
  validSubCategories: ['004'],
  brandSpecific: true,
}

const Tofu = () => <ProductForm product={productOptions} />

export default Tofu
